import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";

import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Card from "react-bootstrap/Card";
import { CancelButton, SaveButton } from "../../../common/Button";
import { Col, Container, Row, Form, InputGroup } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
import { Context } from "../../../../utils/context";
import Offcanvas from "react-bootstrap/Offcanvas";
import ModalSave from "../../../common/ModalSave";
library.add(fas);

const EditOffCanvance = (props) => {
  const id = props.show;
  const { postData, getData, IMG_URL } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  console.log(showModal, "showModal");

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    getValues,
  } = useForm();

  const imageFile = watch("cover_image");

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("name", data?.name);
      sendData.append("training_video", data?.training_video[0]);
      sendData.append("cover_image", data?.cover_image[0]);
      const response = await postData(
        `/masters/training-video/${id}`,
        sendData
      );

      console.log(response?.success, "responseee");

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  const GetEditData = async () => {
    const response = await getData(`/masters/training-video/${id}`);
    reset(response?.data);
  };
  useEffect(() => {
    GetEditData();
  }, []);

  const [videoFile, setVideoFile] = useState(null);

  const handleVideoChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setVideoFile(e.target.files);
    }
  };

  return (
    <>
      <Offcanvas
        show={props.show}
        style={{ width: "80%" }}
        placement={"end"}
        onHide={props.handleClose}
      >
        <Offcanvas.Header closeButton></Offcanvas.Header>
        <Offcanvas.Body>
          {" "}
          <Container fluid>
            {" "}
            <Row>
              {" "}
              <Col md={12}>
                <Card className="shadow-lg p-3 mb-5 bg-white rounded">
                  <Card.Body>
                    <Card.Title>Edit Driver Training Video </Card.Title>
                    <hr />
                    <Container>
                      <Row>
                        {/* Editing fields */}
                        <Col md={8}>
                          <Form
                            onSubmit={() => handleSubmit(onSubmit)}
                            role="form"
                          >
                            <Row className="justify-content-center">
                              <Col md={6}>
                                <div className="main-form-section mt-3">
                                  <Form.Group>
                                    <Form.Label>Name</Form.Label>

                                    <InputGroup>
                                      <Form.Control
                                        type="text"
                                        name="name"
                                        placeholder="Name"
                                        className={classNames("", {
                                          "is-invalid": errors?.name,
                                        })}
                                        {...register("name", {
                                          required: "Name is required",
                                        })}
                                      />
                                    </InputGroup>
                                    {errors.name && (
                                      <span className="text-danger">
                                        {errors.name.message}
                                      </span>
                                    )}
                                  </Form.Group>
                                </div>

                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-start">
                                    <Form.Label className="text-left">
                                      Video
                                    </Form.Label>
                                    <Form.Group>
                                      <Form.Control
                                        className={classNames("", {
                                          "is-invalid": errors?.training_video,
                                        })}
                                        type="file"
                                        {...register("training_video", {
                                          onChange: handleVideoChange,
                                        })}
                                        accept=".mp4, .mov, .avi"
                                      />
                                    </Form.Group>
                                    {errors.training_video && (
                                      <span className="text-danger">
                                        {errors.training_video.message}
                                      </span>
                                    )}
                                  </Row>
                                </div>
                              </Col>
                              <Col lg={6}>
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-center">
                                    <Form.Label
                                      column
                                      sm={3}
                                      className="text-center"
                                    >
                                      Video Preview
                                    </Form.Label>
                                    <Col sm={9}>
                                      {typeof getValues("training_video") ===
                                      "string" ? (
                                        <div className="video-preview-container">
                                          <video
                                            src={
                                              IMG_URL +
                                              getValues("training_video")
                                            }
                                            alt="Preview"
                                            className="video-preview"
                                            style={{
                                              width: "150px",
                                              height: "130px",
                                            }}
                                            controls
                                          />
                                        </div>
                                      ) : (
                                        videoFile &&
                                        videoFile.length > 0 && (
                                          <div className="video-preview-container">
                                            <video
                                              src={URL.createObjectURL(
                                                videoFile[0]
                                              )}
                                              alt="Preview"
                                              className="video-preview"
                                              style={{
                                                width: "150px",
                                                height: "130px",
                                              }}
                                              controls
                                            />
                                          </div>
                                        )
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                              <Col>
                                {" "}
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-start">
                                    <Form.Label className="text-left">
                                      Cover Image
                                    </Form.Label>

                                    <Form.Group>
                                      <Form.Control
                                        className={classNames("", {
                                          "is-invalid": errors?.cover_image,
                                        })}
                                        type="file"
                                        {...register("cover_image", {})}
                                        accept=".jpg, .jpeg, .png"
                                      />
                                    </Form.Group>
                                    {errors.cover_image && (
                                      <span className="text-danger">
                                        {errors.cover_image.message}
                                      </span>
                                    )}
                                  </Row>
                                </div>{" "}
                              </Col>
                              <Col lg={6}>
                                <div className="main-form-section mt-3">
                                  <Row className="justify-content-center">
                                    <Form.Label
                                      column
                                      sm={3}
                                      className="text-center"
                                    >
                                      Cover Image Preview
                                    </Form.Label>
                                    <Col sm={9}>
                                      {typeof getValues("cover_image") ==
                                      "string" ? (
                                        <div className="image-preview-container">
                                          <img
                                            src={
                                              IMG_URL + getValues("cover_image")
                                            }
                                            alt="Preview"
                                            className="image-preview"
                                            style={{
                                              width: "150px",
                                              height: "130px",
                                            }}
                                          />
                                        </div>
                                      ) : (
                                        imageFile &&
                                        imageFile?.length > 0 && (
                                          <div className="image-preview-container">
                                            <img
                                              // src={URL.createObjectURL(getValues("image")[0])}
                                              src={URL?.createObjectURL(
                                                imageFile[0]
                                              )}
                                              alt="Preview"
                                              className="image-preview"
                                              style={{
                                                width: "100px",
                                                height: "100px",
                                              }}
                                            />
                                          </div>
                                        )
                                      )}
                                    </Col>
                                  </Row>
                                </div>
                              </Col>
                              <Row className="mt-5 pb-3">
                                <div className="d-flex justify-content-center">
                                  <Link>
                                    <CancelButton
                                      name={"cancel"}
                                      handleClose={props.handleClose}
                                    />
                                  </Link>

                                  <SaveButton
                                    name={"save"}
                                    handleSubmit={handleSubmit(onSubmit)}
                                  />
                                </div>
                              </Row>
                            </Row>
                          </Form>
                        </Col>
                      </Row>
                    </Container>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};
export default EditOffCanvance;
